import { render, staticRenderFns } from "./VideoTwo.vue?vue&type=template&id=f1d5f376&scoped=true"
import script from "./VideoTwo.vue?vue&type=script&lang=js"
export * from "./VideoTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d5f376",
  null
  
)

export default component.exports